module.exports = __webpack_public_path__ + "media/images/spark-line-flag-979a5ede937495e4b4a951037d3ed95f.png";